import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCameraSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCameraSparkle"><Path d="M21.5 12.5V20.5H2.5V6.5H7.5L9.5 3.5H12.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="12" cy="13" r="3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraSparkle;
